(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('newsletter-popup')) {
    customElements.define(
      'newsletter-popup',
      class NewsletterPopup extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;

          this.storageKey = `newsletter-popup:${this.dataset.sectionId}`;
          this.designMode = this.hasAttribute('data-design-mode');

          this.handleClose = this.handleClose.bind(this);
          this.handleBackdropClick = this.handleBackdropClick.bind(this);
          this.handleSectionSelect = this.handleSectionSelect.bind(this);
          this.handleSectionDeselect = this.handleSectionDeselect.bind(this);

          this.dialog.addEventListener('close', this.handleClose);
          this.dialog.addEventListener('click', this.handleBackdropClick);
          this.querySelectorAll('[data-popup-close]').forEach((button) => {
            button.addEventListener('click', () => this.dialog.close());
          });

          if (this.designMode) {
            document.addEventListener('shopify:section:select', this.handleSectionSelect);
            document.addEventListener('shopify:section:deselect', this.handleSectionDeselect);
            return;
          }

          if (this.querySelector('[data-popup-success]')) {
            this.remember('subscribed');
            this.open();
            return;
          }

          if (this.querySelector('[data-popup-error]')) {
            this.open();
            return;
          }

          if (this.shouldStayHidden()) return;

          const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
          this.timer = window.setTimeout(() => this.open(), delay);
        }

        disconnectedCallback() {
          window.clearTimeout(this.timer);
          document.removeEventListener('shopify:section:select', this.handleSectionSelect);
          document.removeEventListener('shopify:section:deselect', this.handleSectionDeselect);
        }

        read() {
          try {
            return JSON.parse(window.localStorage.getItem(this.storageKey));
          } catch (error) {
            return null;
          }
        }

        remember(status) {
          try {
            window.localStorage.setItem(this.storageKey, JSON.stringify({ status, at: Date.now() }));
          } catch (error) {}
        }

        shouldStayHidden() {
          const saved = this.read();
          if (!saved) return false;
          if (saved.status === 'subscribed') return true;

          const days = Number(this.dataset.frequencyDays) || 0;
          return Date.now() - saved.at < days * 86400000;
        }

        open() {
          if (!this.dialog.open) this.dialog.showModal();
        }

        handleClose() {
          if (this.designMode) return;

          const saved = this.read();
          if (!saved || saved.status !== 'subscribed') this.remember('dismissed');
        }

        handleBackdropClick(event) {
          if (event.target === this.dialog) this.dialog.close();
        }

        handleSectionSelect(event) {
          if (event.detail.sectionId === this.dataset.sectionId) this.open();
        }

        handleSectionDeselect(event) {
          if (event.detail.sectionId === this.dataset.sectionId && this.dialog.open) this.dialog.close();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
